import Breadcrumbs from "components/Common/Breadcrumb"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Button, Card, CardBody, CardTitle } from "reactstrap"
import { Formik, Form } from "lib/formik"
import Select from "components/Shared/TranslatedSelect"
import { useSelector } from "react-redux"
import { getAllBranchs } from "store/actions/usersAction"
import { useDispatch } from "react-redux"
import Switch from "components/Shared/Switch"
import { post } from "helpers/api_helper"
import { QR_CODE_GENERATE, SAVE_DYNAMIC_LINK } from "helpers/url_helper"
import { showAlert } from "store/reducers/alertReducer"
import QRCode from "qrcode.react"
import html2canvas from "html2canvas"
import { jsPDF } from "jspdf"
import StarRatings from "react-star-ratings"
import { generateQrCodeSchema } from "components/Common/validation"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import useTenantDisplayName from "hooks/useTenantDisplayName"
import { getCrossModuleFilterPermissions } from "utils/crossModuleFilterPermissions"
import { navigateToAccessibleRoute } from "utils/navigateUnauthorized"

const initialValues = {
  branchId: "",
  type: "",
}
const GenerateQRCode = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Generate QR Code ")

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const qrCodeRef = useRef(null)

  const [formValues, setFormValues] = useState(initialValues)
  const [qrCodeLink, setQrCodeLink] = useState("")
  const [selectedQrType, setSelectedQrType] = useState(null)
  const [branchName, setBranchName] = useState(null)
  const [branchId, setBranchId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowBranchName, setIsShowBranchName] = useState(false)
  const { branchsList } = useSelector(state => state.Users)
  const tenantDisplayName = useTenantDisplayName()

  const { userRole, accountType, accountScope } = useSelector(
    state => state.Login
  )
  const { canFilterByBranch } = getCrossModuleFilterPermissions(
    userRole,
    accountType,
    accountScope
  )
  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    edit: null,
    generateOrderQr: false,
  })
  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      22,
      "qr_code_1",
      accountType,
      accountScope
    )

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      22,
      "qr_code_3",
      accountType,
      accountScope
    )

    const viewSubs =
      getSubPermissions(userRole, 22, "qr_code_1", accountType, accountScope) ||
      {}
    const editSubs =
      getSubPermissions(userRole, 22, "qr_code_3", accountType, accountScope) ||
      {}
    const generateOrderQr = Boolean(
      viewSubs?.generate_order_qr?.isEnabled ||
        editSubs?.generate_order_qr?.isEnabled ||
        isPermissionEnabled(
          userRole,
          22,
          "generate_order_qr",
          accountType,
          accountScope
        )
    )

    if (!isPermissionList) {
      navigateToAccessibleRoute(navigate, { userRole, accountType })
    }
    setUsersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
      generateOrderQr,
    })
  }, [userRole, accountType, accountScope, navigate])

  useEffect(() => {
    if (canFilterByBranch) {
      dispatch(getAllBranchs())
    }
  }, [canFilterByBranch, dispatch])

  const qrTypeOptions = useMemo(() => {
    const options = [{ label: t("Rating"), value: "rating" }]
    if (usersPermissions.generateOrderQr) {
      options.push({ label: t("Order"), value: "order" })
    }
    return options
  }, [t, usersPermissions.generateOrderQr])

  const handleOnSubmit = async (values, { resetForm }) => {
    const { branchId, type } = values
    const updatedBranchId = branchId.value
    const updatedType = type.value
    const payload = {
      targetObj: {
        branchId: updatedBranchId,
        type: updatedType,
      },
    }

    const response = await post(QR_CODE_GENERATE, payload)

    if (response?.statusCode === 200 && response?.status) {
      dispatch(showAlert({ text: response?.msg, type: "success" }))
      const { link } = response?.data
      setBranchName(branchId.label)
      setQrCodeLink(link)
      setBranchId(updatedBranchId)
      setSelectedQrType(updatedType)
    } else {
      dispatch(showAlert({ text: response?.msg, type: "error" }))
    }
  }

  const exportToPDF = () => {
    if (qrCodeRef.current) {
      html2canvas(qrCodeRef.current, { scale: 5 }).then(canvas => {
        const imgData = canvas.toDataURL("image/png")
        const pdf = new jsPDF()
        const imgProps = pdf.getImageProperties(imgData)
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight)
        pdf.save(`${t("QR-Code")}.pdf`)
      })
    }
  }

  const handelSave = async () => {
    setIsLoading(true)
    const payload = {
      branchId,
      link: qrCodeLink,
      type: selectedQrType || "rating",
    }
    const response = await post(SAVE_DYNAMIC_LINK, payload)
    if (response?.statusCode === 200 && response?.status) {
      dispatch(showAlert({ text: response?.msg, type: "success" }))
    } else {
      dispatch(showAlert({ text: response?.msg, type: "error" }))
    }
    setIsLoading(false)
  }

  const renderTypeBadge = () => {
    if (selectedQrType === "order") {
      return (
        <div className="mb-3 g_center">
          <span className="badge bg-primary fs-6 px-3 py-2">{t("Order")}</span>
        </div>
      )
    }

    return (
      <div className="mb-3 g_center">
        <StarRatings
          rating={5}
          starRatedColor="#F1B44C"
          starEmptyColor="#74788d"
          numberOfStars={5}
          name="rating"
          starDimension="24px"
          starSpacing="3px"
        />
      </div>
    )
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <div className="row">
          <div className="col-lg-6">
            <Card className="full_height_card">
              <CardBody>
                <CardTitle>{t("Generate QR Code")}</CardTitle>
                <Formik
                  initialValues={formValues}
                  onSubmit={handleOnSubmit}
                  validationSchema={generateQrCodeSchema}
                >
                  {({
                    values,
                    setFieldValue,
                    errors,
                    touched,
                    isSubmitting,
                  }) => (
                    <Form>
                      <div className="row ">
                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="branchId">
                              {t("Select Branch")}
                            </label>
                            <Select
                              value={values.branchId || null}
                              onChange={item => {
                                setFieldValue("branchId", item)
                              }}
                              options={(canFilterByBranch
                                ? branchsList || []
                                : []
                              ).map(item => ({
                                label:
                                  language === "sa" ? item.nameAr : item.name,
                                value: item._id,
                              }))}
                              className={`select2-selection ${
                                touched.branchId && errors.branchId
                                  ? "danger_color_border"
                                  : ""
                              } `}
                              placeholder={t("Select Branch")}
                            />
                            <TextError name="branchId" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="type">{t("Select QR Type")}</label>
                            <Select
                              value={values.type || null}
                              onChange={item => {
                                setFieldValue("type", item)
                              }}
                              options={qrTypeOptions}
                              className={`select2-selection ${
                                touched.type && errors.type
                                  ? "danger_color_border"
                                  : ""
                              } `}
                              placeholder={t("Select QR Type")}
                            />
                            <TextError name="type" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="isShowBranchName">
                              {t(
                                "Do You Want To Print Branch Name Underneath The QR Code"
                              )}
                            </label>
                            <Switch
                              isChecked={isShowBranchName}
                              onClickHandler={() =>
                                setIsShowBranchName(!isShowBranchName)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12">
                          {usersPermissions.edit && (
                            <Button
                              type="submit"
                              color="success"
                              className="d-block ms-auto"
                              disabled={isSubmitting}
                            >
                              {t("Generate QR Code")}
                            </Button>
                          )}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </div>
          <div className="col-lg-6">
            <Card className="full_height_card qr_code_view">
              <CardBody className="g_center">
                {qrCodeLink ? (
                  <div>
                    <div ref={qrCodeRef} className="px-4 pb-2">
                      <div className="qr_code">
                        <QRCode
                          value={qrCodeLink}
                          size={250}
                          level="H"
                          includeMargin={true}
                          renderAs="svg"
                        />
                      </div>

                      {renderTypeBadge()}

                      {isShowBranchName && (
                        <p className="text-center fw-bold fs-5 text-black">
                          {branchName}
                        </p>
                      )}
                      <h3 className="text-black text-center fz-bold mt-2">
                        {tenantDisplayName}
                      </h3>
                    </div>
                    <div className="d-flex">
                      <Button
                        color="primary"
                        className="mx-auto d-block mt-3"
                        onClick={exportToPDF}
                        disabled={!qrCodeLink}
                      >
                        {t("Download To PDF")}
                      </Button>
                      <Button
                        color="primary"
                        className="mx-auto d-block mt-3"
                        onClick={handelSave}
                        disabled={isLoading}
                      >
                        {t("Save")}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="px-4 pb-2">
                    <div className="qr_code">
                      <QRCode
                        value="https://example.com"
                        size={250}
                        level="H"
                        includeMargin={true}
                        renderAs="svg"
                      />
                    </div>
                    <div className="mb-3 g_center">
                      <StarRatings
                        rating={5}
                        starRatedColor="#F1B44C"
                        starEmptyColor="#74788d"
                        numberOfStars={5}
                        name="rating"
                        starDimension="24px"
                        starSpacing="3px"
                      />
                    </div>
                    <h3 className="text-black text-center fz-bold mt-2">
                      {tenantDisplayName}
                    </h3>
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GenerateQRCode
